import {
  REPORT_STATUS_LABEL,
  REPORT_STATUS_TINT,
} from "../../lib/diagnostics";

export default function ReportStatusBar({
  status,
  canSubmit,
  canFinalize,
  canReopen,
  busy,
  onSubmit,
  onFinalize,
  onReopen,
}) {
  const tint =
    REPORT_STATUS_TINT[status] || "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <div
      data-testid="report-status-bar"
      className="sticky top-0 z-10 -mx-6 px-6 py-3 bg-white/90 backdrop-blur-sm border-b border-slate-200 flex items-center justify-between gap-3"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
          Diagnostic report
        </div>
        <span
          data-testid={`report-status-${status}`}
          className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${tint}`}
        >
          {REPORT_STATUS_LABEL[status] || status}
        </span>
      </div>
      <div className="flex items-center gap-2">
        {canSubmit && (
          <button
            type="button"
            disabled={busy}
            onClick={onSubmit}
            data-testid="report-submit-button"
            className="inline-flex items-center gap-2 rounded-md bg-slate-900 px-4 py-2 text-[13px] font-semibold text-white hover:bg-slate-800 disabled:opacity-60 transition-colors"
          >
            Submit for Review
          </button>
        )}
        {canFinalize && (
          <button
            type="button"
            disabled={busy}
            onClick={onFinalize}
            data-testid="report-finalize-button"
            className="inline-flex items-center gap-2 rounded-md bg-emerald-600 px-4 py-2 text-[13px] font-semibold text-white hover:bg-emerald-700 disabled:opacity-60 transition-colors"
          >
            Finalize
          </button>
        )}
        {canReopen && (
          <button
            type="button"
            disabled={busy}
            onClick={onReopen}
            data-testid="report-reopen-button"
            className="inline-flex items-center gap-2 rounded-md border border-slate-200 bg-white px-3.5 py-2 text-[13px] font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-60 transition-colors"
          >
            Reopen
          </button>
        )}
      </div>
    </div>
  );
}
